/* eslint-disable max-len */
import type { FC } from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const MinusIcon: FC<IconProps> = ({ ...props }) => {
  return (
    <BaseIcon {...props}>
      <path d="M24 15a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2h16Z" />
    </BaseIcon>
  );
};
